import { backEndAPIUrl } from 'constants/values';

export const fetchUserSetting = async () => {
  const url = `${backEndAPIUrl}/user-settings`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  } else if (response.status === 422) {
    await response.json();
  }
};

export const updateUserSetting = async ({ payload }) => {
  const url = `${backEndAPIUrl}/user-settings`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    method: 'PATCH',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    }),
    body: JSON.stringify(payload),
    credentials: 'include',
    cache: 'no-cache',
  });

  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  }

  const error = new Error(response.statusText);
  throw error;
};
